<template>
  <vx-card class="mt-base" title="Law Activity 3: LSAT Vocabulary Game">
    <p class="mb-5">
      The Law School Admission Test (LSAT) is required for admission to law schools throughout the
      United States and Canada. So, if you have plans to study Law there, you’ll need to pass this
      exam.
    </p>
    <p class="mb-5">
      The LSAT (or similar tests) is also used at several law schools in Australia, and applicants
      can sit for the LSAT in most capital cities in Australia and at locations around the world.
    </p>
    <p class="mb-5">
      Even if the course you want to do doesn’t require you to pass the LSAT, if you are interested
      in working in a legal profession, the skills students learn studying for the LSAT are still
      beneficial.
    </p>
    <p class="mb-5">
      The Law School Admission Test (LSAT) is unlike any test you've ever taken in your academic
      career. The LSAT is a skills-based exam designed to test the critical reading and analytical
      thinking skills crucial for success in law school. A big part of this is having a high-level,
      wide-ranging vocabulary that will help you comprehend the conversations you take part in and
      the papers you’ll have to read and write.
    </p>
    <p class="mb-5">The game below will help test your knowledge of some useful vocabulary.</p>

    <centered-image-wrapper
      :image="image1"
      classes="2/3"
      alt="Law Dojo game instructions: We'll ask you a question about the law and you choose among the multiple choices. If you're right, you win points; if you're wrong, you lose one of your 3 lives. Three wrong answers = game over (or you can use your points to buy lives)."
    />

    <p class="mb-5">
      As you work your way through the quiz, note the words you get wrong and write down the correct
      definitions beside them.
    </p>
    <p class="mb-5">
      Practise your new words until you can get through the whole list of words without losing all
      your lives.
    </p>
    <p class="mb-5">Click the button below to play the game.</p>

    <a href="https://lawdojo.co/p/19/lsat" target="_blank"
      ><centered-image-wrapper
        alt="Open the Law Dojo vocabulary game (opens in a new tab)"
        :image="image2"
    /></a>

    <p class="mb-5">
      Now, record in the space below three new words you learned along with their definitions?
    </p>
    <table class="table default-table">
      <tr class="header">
        <th width="30%">Word</th>
        <th>Definition</th>
      </tr>
      <tr class="body" v-for="index in 3" :key="index">
        <td><text-block v-model="data['question' + index + '_1']" :editable="isEditable" /></td>
        <td><text-block v-model="data['question' + index + '_2']" :editable="isEditable" /></td>
      </tr>
    </table>
    <save-buttons :is-editable="isEditable" @save="save" />

    <p class="my-5">
      If you want to find out more about legal terminology and jargon, you can check out the entries
      in the Queensland Legalpedia via the link below:
    </p>

    <button-link-wrapper
      link="https://www.legalpediaqld.org.au/index.php/Glossary"
      text="Access Legalpedia"
    />
    <h4 class="mb-5">Don’t Forget!</h4>
    <p class="mb-5">
      As you work your way through the Law Virtual job Experience, you may come across words and
      terms you aren’t familiar with. You can check their meanings using the glossary above. It
      might also be a good idea to add it to your computer Bookmarks to help you access it quickly
      when needed.
    </p>
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      image1: require('@/assets/images/experiences/law/law_31.png'),
      image2: require('@/assets/images/experiences/law/law_32.jpg'),
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
